import React from "react";
import { normalizeTags } from "../utils";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

export default function TagDropdown({
  options,
  selected,
  onChange,
  onCreate,
  disabled,
}) {
  const [query, setQuery] = React.useState("");
  const values = React.useMemo(() => normalizeTags(selected), [selected]);
  const choices = React.useMemo(
    () => [...new Set([...options, ...values])],
    [options, values],
  );
  return (
    <Autocomplete
      className="tags tag-input"
      multiple
      disableCloseOnSelect
      disabled={disabled}
      options={choices}
      value={values}
      inputValue={query}
      onInputChange={(_, value, reason) => {
        if (reason === "input" || reason === "clear") setQuery(value);
      }}
      getOptionLabel={(option) =>
        typeof option === "string" ? option : `+ "${option.create}"`
      }
      renderOption={({ key, ...optionProps }, option) => (
        <li key={key} {...optionProps}>
          {typeof option === "string" ? (
            option
          ) : (
            <strong
              className="tag-create-option"
              title={`+ "${option.create}"`}
            >
              {`+ "${option.create}"`}
            </strong>
          )}
        </li>
      )}
      filterOptions={(items, { inputValue }) => {
        const text = inputValue.trim();
        const matches = items.filter((item) =>
          item.toLocaleLowerCase().includes(text.toLocaleLowerCase()),
        );
        if (
          text &&
          !items.some(
            (item) => item.toLocaleLowerCase() === text.toLocaleLowerCase(),
          )
        )
          matches.push({ create: text });
        return matches;
      }}
      onChange={(_, values) => {
        const created = values.find((value) => typeof value !== "string");
        if (created) onCreate?.(created.create);
        onChange(
          values.map((value) =>
            typeof value === "string" ? value : value.create,
          ),
        );
        setQuery("");
      }}
      renderValue={(values) => (
        <span className="tag-selection" title={values.join(", ")}>
          {values.join(", ")}
        </span>
      )}
      slotProps={{
        popper: { placement: "bottom-start" },
        listbox: { sx: { maxHeight: 240 } },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Tags"
          slotProps={{
            ...params.slotProps,
            htmlInput: { ...params.slotProps.htmlInput, "aria-label": "Tags" },
          }}
        />
      )}
    />
  );
}
